<template>
  <div class="contact-page">
    <!-- Hero Banner -->
    <div class="contact-hero">
      <div class="contact-hero-inner">
        <font-awesome-icon icon="fa-solid fa-paper-plane" class="contact-hero-icon" />
        <h1>{{ $t('contact_page_title') }}</h1>
        <p>{{ $t('contact_page_subtitle') }}</p>
      </div>
    </div>

    <!-- Main content: info + map -->
    <b-container fluid class="contact-main px-0">
      <!-- Section title -->
      <b-row no-gutters class="contact-section-title-row">
        <b-col>
          <div class="contact-section-title">
            <span class="contact-section-line"></span>
            <span class="contact-section-text">
              <font-awesome-icon icon="fa-solid fa-location-dot" />
              お問い合わせ・アクセス
            </span>
            <span class="contact-section-line contact-section-line--right"></span>
          </div>
        </b-col>
      </b-row>

      <b-row no-gutters class="contact-main-row">
        <!-- Left: company info -->
        <b-col md="5" class="contact-info-col">
          <div class="contact-info-inner">
            <div class="contact-company-name">
              <font-awesome-icon icon="fa-solid fa-building" class="contact-company-icon" />
              <span>株式会社ASUKA</span>
            </div>

            <div class="contact-info-card">
              <div class="contact-info-item">
                <div class="contact-info-icon-wrap">
                  <font-awesome-icon icon="fa-solid fa-phone" />
                </div>
                <div class="contact-info-text">
                  <span class="contact-info-label">TEL</span>
                  <a href="tel:0529779445" class="contact-info-value">052-977-9445</a>
                </div>
              </div>
              <div class="contact-info-item">
                <div class="contact-info-icon-wrap">
                  <font-awesome-icon icon="fa-solid fa-fax" />
                </div>
                <div class="contact-info-text">
                  <span class="contact-info-label">FAX</span>
                  <span class="contact-info-value">052-977-4660</span>
                </div>
              </div>
              <div class="contact-info-item">
                <div class="contact-info-icon-wrap">
                  <font-awesome-icon icon="fa-solid fa-envelope" />
                </div>
                <div class="contact-info-text">
                  <span class="contact-info-label">MAIL</span>
                  <a href="mailto:truong@asuka-n.jp" class="contact-info-value">truong@asuka-n.jp</a>
                </div>
              </div>
              <div class="contact-info-item">
                <div class="contact-info-icon-wrap">
                  <font-awesome-icon icon="fa-solid fa-location-dot" />
                </div>
                <div class="contact-info-text">
                  <span class="contact-info-label">ADDRESS</span>
                  <span class="contact-info-value contact-address">〒455-0073 愛知県名古屋市港区川西通4-9-2 ASUKAビル3F</span>
                </div>
              </div>
            </div>

            <!-- Contact CTA button -->
            <button class="contact-cta-btn" @click="openModal">
              <font-awesome-icon icon="fa-solid fa-paper-plane" />
              <span>{{ $t('contact_btn_label') }}</span>
            </button>
          </div>
        </b-col>

        <!-- Right: map -->
        <b-col md="7" class="contact-map-col px-0">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52202.51248507835!2d136.8521914347273!3d35.14023141705789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60037940ce2ff063%3A0xd42049b2ba49bff7!2z5qCq5byP5Lya56S-QVNVS0E!5e0!3m2!1svi!2sjp!4v1698154232068!5m2!1svi!2sjp"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            class="contact-map-iframe"
          ></iframe>
        </b-col>
      </b-row>
    </b-container>

    <!-- Contact Modal -->
    <contact-modal :visible="isModalOpen" @close="closeModal" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ContactModal from '@/components/ContactModal.vue';

export default {
  name: 'Contact',
  components: { ContactModal },
  data() {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    ...mapActions(['setTab']),
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
  mounted() {
    this.setTab(4);
  },
};
</script>

<style scoped>
.contact-page {
  height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
}

/* Hero */
.contact-hero {
  background: linear-gradient(135deg, #111c55 0%, #1e3a8a 60%, #2563eb 100%);
  padding: 80px 20px 60px;
  text-align: center;
  color: #fff;
}
.contact-hero-inner {
  max-width: 600px;
  margin: 0 auto;
}
.contact-hero-icon {
  font-size: 2.8rem;
  margin-bottom: 16px;
  opacity: 0.9;
}
.contact-hero h1 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: 0.04em;
}
.contact-hero p {
  font-size: 1rem;
  opacity: 0.85;
  line-height: 1.7;
  margin: 0;
}

/* Main layout */
.contact-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

/* Section title */
.contact-section-title-row {
  background: #f0f2fb;
  padding: 22px 40px 18px;
  border-bottom: 1px solid #e2e6f5;
}
.contact-section-title {
  display: flex;
  align-items: center;
  gap: 16px;
}
.contact-section-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, transparent, #1e3a8a55);
}
.contact-section-line--right {
  background: linear-gradient(270deg, transparent, #1e3a8a55);
}
.contact-section-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 700;
  color: #111c55;
  letter-spacing: 0.12em;
  white-space: nowrap;
}
.contact-main-row {
  display: flex !important;
  flex: 1;
  align-items: stretch;
  overflow: hidden;
}

/* Info column */
.contact-info-col {
  background: #f8f9ff;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.contact-info-inner {
  padding: 50px 40px;
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
}
.contact-company-name {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: 800;
  color: #111c55;
  margin-bottom: 28px;
}
.contact-company-icon {
  font-size: 1.3rem;
  color: #1e3a8a;
}

/* Info card */
.contact-info-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(17, 28, 85, 0.08);
  margin-bottom: 32px;
}
.contact-info-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f0f2fa;
}
.contact-info-item:last-child {
  border-bottom: none;
}
.contact-info-icon-wrap {
  width: 36px;
  height: 36px;
  background: #e8ecfa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111c55;
  font-size: 0.9rem;
  flex-shrink: 0;
  margin-top: 2px;
}
.contact-info-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-info-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #999;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
}
.contact-info-value {
  font-size: 0.95rem;
  color: #222;
  font-weight: 500;
  text-decoration: none;
  line-height: 1.5;
  text-align: left;
}
.contact-info-value:hover {
  color: #1e3a8a;
}
.contact-address {
  line-height: 1.6;
  white-space: normal;
  word-break: break-word;
}
@media (max-width: 992px) {
  .contact-address {
    white-space: normal;
  }
}

/* CTA Button */
.contact-cta-btn {
  width: 100%;
  background: linear-gradient(135deg, #111c55 0%, #1e3a8a 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  padding: 16px 24px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 4px 16px rgba(17, 28, 85, 0.25);
  letter-spacing: 0.02em;
}
.contact-cta-btn:hover {
  opacity: 0.92;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(17, 28, 85, 0.3);
}
.contact-cta-btn:active {
  transform: translateY(0);
}

/* Map column */
.contact-map-col {
  min-height: 600px;
  flex: 1;
  display: flex;
}
.contact-map-iframe {
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: 0;
  display: block;
  flex: 1;
}

/* Mobile */
@media (max-width: 768px) {
  .contact-hero h1 {
    font-size: 1.6rem;
  }
  .contact-hero {
    padding: 60px 20px 40px;
  }
  .contact-info-inner {
    padding: 36px 20px;
  }
  .contact-map-col {
    min-height: 400px;
    height: 400px;
  }
  .contact-map-iframe {
    min-height: 400px;
    height: 400px;
  }
}
</style>